// extracted by mini-css-extract-plugin
export default {"partners":"Partners_partners__mBSF6","logo_holder":"Partners_logo_holder__Ev7vE"};